import React from 'react';

export const ptsdCombatTitle = (
  <h3 className="vads-u-font-size--h4">PTSD combat</h3>
);

export const ptsdNonCombatTitle = (
  <h3 className="vads-u-font-size--h4">
    PTSD non-combat (other than sexual trauma or personal assault)
  </h3>
);

export const ptsdBypassRadioLabel =
  'Is your PTSD related to a situation where you feared hostile military or terrorist activity during your military service?';

export const ptsdBypassAdditionalInfo = (
  <va-additional-info trigger="Why we ask this question">
    If your PTSD is related to a situation where you feared hostile military or
    terrorist activity, we don’t need to get more details from you at this time
    about the events that caused your PTSD. We’ll take you straight to the
    supporting evidence section of the application.
  </va-additional-info>
);

export const ptsdBypassDescription =
  'PTSD related to feared hostile military or terrorist activity';
